"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.kinaseInfo = exports.kinaseGroupNames = exports.exampleStyles = exports["default"] = void 0;
var _CoralMap = _interopRequireDefault(require("./CoralMap"));
var _kinaseInfo = require("./kinaseInfo");
var _exampleStyles = require("./exampleStyles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = _CoralMap["default"];
var kinaseGroupNames = exports.kinaseGroupNames = _kinaseInfo.kinaseGroupNames;
var kinaseInfo = exports.kinaseInfo = _kinaseInfo.kinaseInfo;
var exampleStyles = exports.exampleStyles = _exampleStyles.exampleStyles;